import React from 'react';
import PropTypes from 'prop-types';

/**
 * Reusable Text Input field
 * @param {object} props - props object
 * @param {function} props.onChange - function to be called when input is changed
 * @param {string} props.classNames - class names for input field
 * @param {string} props.ariaLabel - aria label for input field
 * @param {object} props.restAttributes - rest of the attributes for input field
 * @returns {element} - input field
 */
const TextFieldInput = React.forwardRef(
	(
		{ onChange, classNames = '', ariaLabel = '', textInputChange, ...restattributes },
		ref,
	) => {
		return (
			<input
				type='text'
				className={classNames}
				onChange={onChange}
				ref={ref}
				aria-label={ariaLabel ?? 'text input field'}
				{...restattributes}
			/>
		);
	},
);

TextFieldInput.propTypes = {
	onChange: PropTypes.func,
	classNames: PropTypes.string,
	restattributes: PropTypes.object,
	ariaLabel: PropTypes.string,
	textInputChange: PropTypes.func,
};

// TextFieldInput.defaultProps = {
// 	onChange: () => {},
// 	classNames: '',
// 	ariaLabel: '',
// 	textInputChange: () => {},
// 	restattributes: {},
// };

export default TextFieldInput;
